import {
  type FC,
  type ReactNode,
  createContext,
  useContext,
  useState,
} from 'react';

type SignUpAppealModalContextValue = {
  isOpened: boolean;
  setIsOpened: (opened: boolean) => void;
};

const SignUpAppealModalContext = createContext<
  SignUpAppealModalContextValue | undefined
>(undefined);

export const useSignUpAppealModal = () => {
  const context = useContext(SignUpAppealModalContext);
  if (context === undefined) {
    throw new Error(
      'useSignUpAppealModal must be used within SignUpAppealModalProvider',
    );
  }
  return context;
};

type Props = {
  children: ReactNode;
};

export const SignUpAppealModalProvider: FC<Props> = ({children}) => {
  const [isOpened, setIsOpened] = useState(false);

  return (
    <SignUpAppealModalContext.Provider value={{isOpened, setIsOpened}}>
      {children}
    </SignUpAppealModalContext.Provider>
  );
};
